import { render, staticRenderFns } from "./Searchresults.vue?vue&type=template&id=5fad149b&"
import script from "./Searchresults.vue?vue&type=script&lang=js&"
export * from "./Searchresults.vue?vue&type=script&lang=js&"
import style0 from "./Searchresults.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Searchresults.vue"
export default component.exports